import { useCallback, useState } from 'react';
import { Status } from '../status';
import { Lenses } from '../lenses';
import { Delivery } from '../delivery';
import { CancelOrderButton } from '../cancel-order/cancel-order-button';
import {
  IProduct,
  OrderStatus,
  OrderType,
} from '../../../../../../graphql/order/models/get-orders.models';
import {
  getIsFulfilledOrder,
  isOrderClosed,
} from '../utils/get-order-status';
import { getCoveredPackages, getOrderPackages } from '../utils';
import { IOrderNoEditProps } from './order-no-edit.models';
import { OrderPriceSummary } from '../order-price/order-price-summary';
import { PickupPointInfo } from '../pick-up-point/pickup-point-info';

export const OrderNoEdit = ({
  storeData, products, points, status, orderId, store, deliveryDate, oldDeliveryDate, lastModifiedDateTime, purchaseDate,
  orderPrice, orderType, deliveryInformation, bonus,
}: IOrderNoEditProps): JSX.Element => {
  const [orderStatus, setOrderStatus] = useState<OrderStatus | undefined>(status);

  const isDelivery = orderType === OrderType.delivery;
  const isC2C = orderType === OrderType.clickToCollect;
  const packageNumber = Math.max(getOrderPackages(products as IProduct[]) - getCoveredPackages(bonus), 0);

  const updateStatus = useCallback((value: OrderStatus) => {
    setOrderStatus(value);
  }, [setOrderStatus]);

  return (
    <>
      <Status
        status={orderStatus!}
        deliveryDate={deliveryDate}
        oldDeliveryDate={oldDeliveryDate}
        purchaseDate={purchaseDate}
        lastModifiedDateTime={lastModifiedDateTime}
        orderType={orderType}
      />
      <Lenses
        products={products}
      />
      {orderPrice && !isC2C && (
        <OrderPriceSummary
          orderPrice={orderPrice}
          points={points}
          packageNumber={packageNumber}
        />
      )}
      {isDelivery ? (
        <PickupPointInfo deliveryInformation={deliveryInformation} store={store} />
      ) : (
        <Delivery
          storeData={storeData}
          isActiveStatus={!isOrderClosed(orderStatus)}
          isFulfilledOrder={getIsFulfilledOrder(orderStatus)}
          purchaseDate={purchaseDate}
          isNewOrder={orderStatus === OrderStatus.new}
        />
      )}
      {!isOrderClosed(orderStatus) && (
        <CancelOrderButton
          orderId={orderId}
          updateStatus={updateStatus}
          isDelivery={isDelivery}
        />
      )}
    </>
  );
};
